const notificationFor = position => experience =>
  experience.parameters &&
  experience.parameters.position === position &&
  experience.parameters.content &&
  experience.variantLabel === 'Experiment';

export default (experiences = []) => {
  const topNotification = experiences.find(notificationFor('top'));
  const bottomNotification = experiences.find(notificationFor('bottom'));

  return {
    topNotification,
    bottomNotification,
  };
};
